import { Injectable } from "@angular/core";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";
import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import { retry } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SancionesPersonasService
  implements RequestCRUD<any, ResponseServiceModel>
{
  private API_URL;

  constructor(
    private http: HttpClient,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = this.enviromentGlobalService.apiUrl;
  }

  get(): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  update(): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  create(): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  delete(): import("rxjs").Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getSancionesPersonaActuales(id: string, body: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SancionesPersonas/GetSancionesPersonaNumeroIdentificacion/${id}`,
          body
      )
      .pipe(retry(2));
  }
  getEstadosSanciones(): Observable<ResponseServiceModel>{
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/EstadosSanciones`
      )
      .pipe(retry(2));
  }
  crearPersona(entry: any): Observable<ResponseServiceModel>{
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SancionesPersonas/CrearPersona`,
        entry
      )
      .pipe(retry(2));
  }
  crearSancionPersona(entry: any): Observable<HttpEvent<any>> {
    const input = new FormData();
    input.append("titulo", entry.titulo);
    input.append("fecha_inicio", entry.fecha_inicio);
    input.append("fecha_fin", entry.fecha_fin);
    input.append("motivo", entry.motivo);
    input.append("numero_identificacion", entry.numero_identificacion);
    input.append("nombre_a_mostrar", entry.nombre_a_mostrar);
    input.append("correo_electronico_fiscal", entry.correo_electronico_fiscal);
    input.append("solicitud_id", entry.solicitud_id);
    input.append("archivo", entry.archivo, entry.archivo.name);

    const uploadReq = new HttpRequest(
      "POST",
      `${this.API_URL}/SancionesPersonas/Crear/${entry.codigo_camara}`,
      input
    );
    return this.http.request<HttpEvent<any>>(uploadReq).pipe(retry(2));
  }

  eliminarSancion(id: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/SancionesPersonas/CambiarEstadoSancionPersona/${id}`
      )
      .pipe(retry(2));
  }

  getDatosPrestador(body: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SancionesPersonas/GetPersonaSancion/`,body
      )
      .pipe(retry(2));
  }
  getHistorial(id: any,pageNumber:number): Observable<any> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SancionesPersonas/GetHistorial?PageNumber=${pageNumber}&PageSize=12`,
        id
      )
      .pipe(retry(2));
  }
  validarSanciones(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/SancionesPersonas/ValidarSancion`
      )
      .pipe(retry(2));
  }
}
